export default "__VITE_ASSET__CCN_EYao__"